import { GRID_DETAILS_SERVICE_NAME, GridDetailsServiceProvider } from './grid-details.service'

export const GRID_DETAILS_SERVICES_MODULE_NAME = 'simax.services.gridDetails'

const module = angular.module(GRID_DETAILS_SERVICES_MODULE_NAME, [])

module.provider(GRID_DETAILS_SERVICE_NAME, GridDetailsServiceProvider)
